// extracted by mini-css-extract-plugin
export var barContainer = "_50-0";
export var extraThin = "_50-3";
export var fillBar = "_50-6";
export var fillContainer = "_50-4";
export var overflow = "_50-8";
export var overflowContainer = "_50-5";
export var regular = "_50-7";
export var thick = "_50-1";
export var thin = "_50-2";